import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from "rxjs/operators";
import {Router} from "@angular/router";
import {SnackbarService} from '../_services/snackbar.service';
import {AuthService} from "../_services/auth.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private router: Router, private snack: SnackbarService, private authService: AuthService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(error => {

            if (!navigator.onLine) {
                // User is offline
                return throwError('You appear to be offline. Please check your internet connection and try again.');
            }

            if ((error.status === 403 || error.status === 401 || error.status == 408) && !location.pathname.includes('login')) {
                // auto logout if 403 response returned from api
                if (error.status === 403) {
                    this.snack.openErrorSnackBar('We\'re sorry, but you don\'t have permission to access this resource. If you believe this is an error, please contact support.');
                    this.authService.logout();
                } else if (error.status === 408 && !location.pathname.includes('login')) {
                    this.snack.openErrorSnackBar('User logged out due to inactivity');
                    // Only return to previous location if the user had access to that page. (stops loop)
                    if (window.location.href.includes('returnUrl')) {
                        let url: URL = new URL(window.location.href);
                        url.searchParams.delete('returnUrl'); // Removes the 'returnUrl' parameter
                        this.authService.logout(encodeURIComponent(url.pathname + url.search));
                    } else {
                        this.authService.logout(encodeURIComponent(window.location.pathname + window.location.search));
                    }
                } else {
                    this.authService.logout()
                }

            }
            if (error.status === 413) {
                this.snack.openErrorSnackBar('The uploaded file/content is too large. Please upload a smaller one.')
                return throwError((): null => null);
            }
            if (error.status === 0) {
                if (request.body instanceof FormData) {
                    const formData: FormData = request.body;
                    let containsFile: boolean = false;

                    formData.forEach((value, key): void => {
                        if (value instanceof File) {
                            containsFile = true;
                        }
                    });

                    if (containsFile) {
                        this.snack.openErrorSnackBar('The uploaded file/content is too large. Please upload a smaller one.')
                        return throwError((): null => null);
                    }
                } else {
                    const isFirefox: boolean = navigator.userAgent.toLowerCase().includes('firefox');

                    if (isFirefox) {
                        // Possibly a NS_ERROR_NET_RESET so logout user
                        this.snack.openErrorSnackBar('A network error occurred. Please check your internet connection or try again later.');
                        this.authService.logout();
                        return throwError((): null => null);
                    } else {
                        this.snack.openErrorSnackBar('A network error occurred. Please check your internet connection or try again later.');
                        return throwError((): null => null);
                    }
                }
            }

            let displayError: string = 'An error has occurred; please try again later.'
            if (error.error?.detail) {
                displayError = error.error.detail;
            } else if (error.error?.message?.en) {
                displayError = error.error.message.en;
            } else if (error.error?.message) {
                if (typeof error.error.message == "object") {
                    let message: string = 'Error: '
                    for (const property in error.error.message) {
                        message = message + `${property}: ${error.error.message[property]} `
                    }
                    displayError = message;
                } else {
                    displayError = JSON.stringify(error.error.message);
                }
            } else if (error.error?.error) {
                displayError = error.error.error;
            } else if (error.message) {
                displayError = error.message;
            }

            return throwError(displayError);
        }));
    }
}
